import { faPlus, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { AverbacaoInterface, SeguroInterface } from "../../../interfaces";
import { useState } from "react";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { getPseudoID } from "../../../utils/utils";

interface formProps {
    form: SeguroInterface;
    setForm: React.Dispatch<React.SetStateAction<SeguroInterface>>
}

const Averbacao: React.FC<formProps> = ({ form, setForm }) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<number>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [numero, setNumero] = useState<string>('');

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number) => {
        setSelected(id);
        setShowModal(true);
    }

    const removerTudo = () => {
        if (form.nAver.length > 0) {

            setForm({
                ...form,
                nAver: []
            });
        }

    }

    const validaPreenchimento = () => {
        if (form.cpfcnpj.trim() === "") {
            alerta('Informe o CPF/CNPJ do seguro.')
            return false;
        }

        if (numero.trim() === "") {
            alerta('Informe o número da avebação')
            return false;
        }

        if (form.nAver.find((item: AverbacaoInterface) => item.nAver === numero.trim())) {
            alerta('Número da avebação já foi adicionado.')
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            setForm({
                ...form,
                nAver: [...form.nAver, { id: getPseudoID(), nAver: numero.trim() }]
            })
            setNumero('');
        }
    }

    const handleRemover = (id: number) => {
        if (form.nAver.length > 0) {
            if (form.nAver.find(item => item.id === id)) {
                setForm({
                    ...form,
                    nAver: form.nAver.filter(item => item.id !== id)
                })
            }
        }
        setShowModal(false);
    }

    return (<>
        <div className="nav nav-underline" id="v-pills-tab" role="tablist">
            <button className="nav-link active" id="tab1-tab" data-bs-toggle="pill" data-bs-target="#tab1"
                type="button" role="tab">Averbações do seguro (Opcional)</button>
        </div>

        <div className="tab-content pt-2 px-2" id="v-pills-tabContent">
            <div className="tab-pane fade show active" id="tab1" role="tabpanel">
                <Row className="mb-3 g-2">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Número da averbação</Form.Label>
                            <Form.Control maxLength={40} value={numero} onChange={(e) => setNumero(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button onClick={handleAdd} title="Adicionar um condutor a lista">
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>

                    </Col>
                </Row>
                <Table striped bordered hover size="sm">
                    <thead className="table-light">
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>
                                <a href="javasctipt:void(0)" className="text-danger" title="Remover todos"
                                    onClick={() => removerTudo()}>
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </a>
                            </th>
                            <th>Número da averbação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {form.nAver?.map((item: AverbacaoInterface) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <a href="javasctipt:void(0)" className="text-danger"
                                        onClick={() => handleOpenModal(item.id)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </a>
                                </td>
                                <td>{item.nAver}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={''}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default Averbacao;
